import React from 'react';

interface CmsSpecialPricingTextButton {
  text: string;
  url: string;
  variant: string;
  inverted: boolean;
  icon: string;
  icon_position: string | null;
  external: boolean;
}

interface CmsSpecialPricingTextData {
  name?: string;
  component?: string;
  body?: string;
  media?: { url: string } | null;
  media_position?: string;
  buttons?: CmsSpecialPricingTextButton[];
}

interface CmsSpecialPricingTextProps {
  data: CmsSpecialPricingTextData;
}

export const CmsSpecialPricingText: React.FC<CmsSpecialPricingTextProps> = ({ data }) => {
  if (!data.name && !data.body) {
    return null;
  }

  const handleButtonClick = (button: CmsSpecialPricingTextButton) => {
    if (!button.url) return;
    if (button.external) {
      window.open(button.url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = button.url;
    }
  };

  return (
    <section className="w-full flex justify-center pt-200 px-500 pb-400">
      <div
        className="w-full flex flex-col md:flex-row items-start justify-between max-w-[1280px]"
        style={{ gap: '133px' }}
      >
        {/* Heading */}
        {data.name && (
          <h2 className="m-0 flex-shrink-0 font-sans text-heading-225 font-bold leading-heading tracking-[-1.44px] text-gray-925">
            {data.name}
          </h2>
        )}

        {/* Body + Button */}
        <div className="flex flex-col items-start flex-1 self-stretch max-w-[628px]">
          {data.body && (
            <p
              className="m-0 font-sans text-body-125 font-medium leading-body text-gray-925"
              dangerouslySetInnerHTML={{ __html: data.body }}
            />
          )}

          {data.buttons && data.buttons.length > 0 && (
            <div className="flex gap-40 mt-250">
              {data.buttons.map((button) => (
                <button
                  key={button.text}
                  onClick={() => handleButtonClick(button)}
                  className="inline-flex items-center gap-40 bg-transparent border-0 cursor-pointer p-0 font-sans text-action-100 font-semibold text-primary underline"
                >
                  {button.text}
                  {button.icon === 'arrow' && (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.333 8h9.334M8.667 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CmsSpecialPricingText;
